// extracted by mini-css-extract-plugin
module.exports = {"page-header-base":"PageHeader_page-header-base__5mVkn","page-header-background":"PageHeader_page-header-background__1FhwV","page-header-text":"PageHeader_page-header-text__3aJZ1"};